import { MembershipHelper, MembershipPlugin } from '@common/membership/shared';
import { of } from 'rxjs';
import { MembershipRegistrationDataInsurance2025Model } from './models';
export class Insurance2025MembershipPlugin extends MembershipPlugin {
  static getInfo() {
    return {
      id: 'insurance-2025',
      name: 'Krankenversicherung 2025',
      description: "Registrierung mit Kostenübernahme durch gesetzliche Krankenkasse",
      paymentRequired: false
    };
  }
  calculateValidUntil(existingMembershipValidity) {
    return MembershipHelper.calculateValidUntil(180, existingMembershipValidity);
  }
  getLabelForField(fieldId) {
    switch (fieldId) {
      case 'email':
        return 'E-Mail-Adresse';
      case 'phone':
        return 'Telefonnummer (optional)';
      case 'firstName':
        return 'Vorname';
      case 'lastName':
        return 'Nachname';
      // case 'password': return 'Passwort';
      case 'isPrivateInsurance':
        return 'Art Ihrer Versicherung';
      case 'insuranceId':
        return 'Name Ihrer Versicherung';
      case 'insuranceMembershipId':
        return 'Versichertennummer';
      case 'allow3rdPartyContact':
        return 'Zustimmung zur Kontaktaufnahme ';
      case 'address':
        return 'Straße und Hausnr.';
      case 'zipcode':
        return 'Postleitzahl';
      case 'city':
        return 'Stadt';
      case 'specifyNursedPerson':
        return 'Ich pflege eine andere Person';
      case 'nursed_isPrivateInsurance':
        return 'Art der Versicherung';
      case 'nursed_insuranceId':
        return 'Name der Versicherung';
      case 'nursed_insuranceMembershipId':
        return 'Versichertennummer der gepfl. Person';
      case 'nursed_firstName':
        return 'Vorname der gepflegten Person';
      case 'nursed_lastName':
        return 'Nachname der gepflegten Person';
      case 'acceptTerms':
        return 'Einwilligung AGB';
    }
    return '<' + fieldId + '>';
  }
  getDisplayValue(fieldId, value) {
    if (fieldId === 'insuranceId') return this.getInsuranceById(value)?.name || 'Unbekannt (' + value + ')';
    return super.getDisplayValue(fieldId, value);
  }
  getFormDataModel() {
    return MembershipRegistrationDataInsurance2025Model;
  }
  getFormDataFields(withAccountData = false) {
    const rows = ['insuranceId', 'insuranceMembershipId', 'address', 'zipcode', 'city', 'specifyNursedPerson', 'nursed_insuranceId', 'nursed_insuranceMembershipId', 'nursed_firstName', 'nursed_lastName'];
    if (withAccountData) {
      rows.push('firstName', 'lastName', 'email', 'phone', 'allow3rdPartyContact');
    }
    return rows;
  }
  getCategorizationLabel(categoryValue) {
    if (!categoryValue) return '-';
    const insurance = this.getInsuranceById(categoryValue);
    return insurance?.name || '???';
  }
  generateSummaryData(data, withAccountData = false) {
    const fieldIds = this.getFormDataFields(withAccountData);
    const rows = fieldIds.map(field => {
      return {
        label: this.getLabelForField(field),
        value: this.getDisplayValue(field, data[field])
      };
    });
    return of([{
      id: 'default',
      title: 'Ihre Angaben',
      rows
    }]);
  }
  generateReportData(memberships, detailed) {
    const reports = [];
    const info = this.getStaticPluginInfo();
    const membershipsGroupedByCategory = new Map();
    memberships.forEach(membership => {
      const existing = membershipsGroupedByCategory.get(membership.membershipTypeCategorization) || [];
      const newList = [...existing, membership];
      membershipsGroupedByCategory.set(membership.membershipTypeCategorization, newList);
    });
    membershipsGroupedByCategory.forEach((entries, categoryName) => {
      const name = categoryName ? this.getInsuranceById(categoryName)?.name || categoryName : 'Unbekannt';
      const id = categoryName || 'unknown';
      reports.push({
        name,
        id,
        membershipType: info.id,
        entries
      });
    });
    return reports;
  }
  getRegistrationDataFields() {
    return ['insuranceId', 'insuranceMembershipId', 'address', 'zipcode', 'city', 'specifyNursedPerson', 'nursed_insuranceId', 'nursed_insuranceMembershipId', 'nursed_firstName', 'nursed_lastName'];
  }
  getReportColumnHeaders() {
    return this.getRegistrationDataFields().map(field => this.getLabelForField(field));
  }
  getReportColumnValues(membership, data) {
    return this.getRegistrationDataFields().map(field => {
      return this.getDisplayValue(field, data[field]) || '-';
    });
  }
  preparePersistedRegistrationData(data) {
    return data;
  }
}